import HrnAvatar from "./HrnAvatar";

export default HrnAvatar;
